import { logout } from 'store/auth/thunks';

import { httpClient } from './httpClient';

export const setupInterceptors = ({
  dispatch,
  history,
}: {
  dispatch: any;
  history: any;
}) => {
  httpClient.interceptors.response.use(
    (response) => response,
    async (error) => {
      const status = error?.response?.status;

      if (status && status === 401) {
        await dispatch(logout());
        history.push('/login', { errorCode: 401 });
      }

      // if (status && status === 403) {
      //   dispatch(logout());
      //   history.push(`/${document.location.search ?? ''}`);
      // }

      /**
       * Any status codes that falls outside the range of 2xx cause this function to trigger
       * Do something with response error
       */
      return Promise.reject(error);
    }
  );
};
